
import { SYMBOL } from "@/collocate"
import BalanceCom from "@/components/BalanceCom"
import ButtonDefault from "@/components/ButtonDefault"
import ButtonPrimary from "@/components/ButtonPrimary"
import PresentData from "@/components/PresentData"
import ScrollView from "@/components/ScrollView"
import { GetDemandsType } from "@/interface"
import useFlowClaim from "@/web3Hook/useFlowClaim"
import useFlowWithdraw from "@/web3Hook/useFlowWithdraw"
import useGetDemandsByLimit from "@/web3Hook/useGetDemandsByLimit"
import useGetDemands from "@/web3Hook/useGetdemands"
import useUnextractedEarnings from "@/web3Hook/useUnextractedEarnings"
import { Tooltip } from "antd"
import { formatUnits } from "ethers"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import dayjs from 'dayjs';

const leftClassName = " font-light text-a8 text-13px"
const rightClassName = " font-light text-white text-13px font-semibold"

const History = () => {
    // 获取订单
    const { getDemandsByLimit, data, getDemandsLod, end } = useGetDemandsByLimit()
    return (
        <ScrollView className="bg-3c rounded-lg mx-2.5 md:mx-6" scroll={{ isOver: end, loading: getDemandsLod, onScroll: getDemandsByLimit }} px={"12.8125rem"}>
            {data.map((item, index) => {
                return <div key={index}>
                    <HistoryItem item={item} />
                </div>
            })}
        </ScrollView>
    )
}



const HistoryItem = (props: { item: GetDemandsType }) => {
    const { t } = useTranslation()
    const { item } = props
    // 真正使用的数据
    const [data, setData] = useState(item)
    // 获取账单的未提取收益
    const { unextractedEarnings, unextractedEarningsBalanceLod, getUnextractedEarnings } = useUnextractedEarnings()
    // 单独获取数据
    const { demandsLod, getDemands } = useGetDemands()
    // 更新
    const update = () => {
        // 单独获取账单数据
        getDemands(data.id).then((res) => {
            setData(res)
        })
        // 获取账单未提取收益
        getUnextractedEarnings(data.id)
    }
    // 提取收益
    const { getFlowClaim, flowClaimLod } = useFlowClaim()
    // 赎回
    const { getFlowWithdraw, flowWithdrawLod } = useFlowWithdraw()

    const getFlowClaimFun = () => {
        getFlowClaim(data.id, {
            success: t('flow.successfulExtractionOfRevenue'),
            error: t('flow.failureToExtractRevenue'),
        },
            update
        )
    }
    const getFlowWithdrawFun = () => {
        getFlowWithdraw(data.id, {
            success: t('flow.redeemedSuccessfully'),
            error: t('flow.redemptionFailed'),
        },
            update
        )
    }
    useEffect(() => {
        getUnextractedEarnings(item.id)
    }, [getUnextractedEarnings, item.id])
    return <div className="relative box-border px-5 md:px-6 pt-15">
        <div className=" flex items-center justify-center rounded-e-xl absolute top-4 left-[-10px] w-17.75 h-6 font-normal text-xs md:text-sm text-adad  bg-53  px-3 ">
            ID：{Number(formatUnits(data.id, 0)) + 1}
        </div>
        <div className=" flex items-center justify-between mb-6">
            <span className={leftClassName}>{t('flow.stakingAmount')}</span>
            <BalanceCom className={rightClassName} balance={data.amount} loading={demandsLod} text={SYMBOL} />
        </div>
        <div className="flex items-center justify-between  mb-6">
            <span className={leftClassName}>{t('flow.cumulativeWithdrawalIncome')}</span>
            <Tooltip placement="topLeft" title={formatUnits(data.totalReward)} arrow>
                <div>
                    <BalanceCom className={rightClassName + " cursor-pointer "} balance={data.totalReward} loading={demandsLod} text={SYMBOL} />
                </div>
            </Tooltip>
        </div>
        <div className=" flex items-center justify-between  mb-6">
            <span className={leftClassName}>{t('flow.unattractedEarnings')}</span>
            <Tooltip placement="topLeft" title={formatUnits(unextractedEarnings)} arrow>
                <div>
                    <BalanceCom className={rightClassName + " cursor-pointer"} balance={unextractedEarnings} loading={unextractedEarningsBalanceLod} text={SYMBOL} />
                </div>
            </Tooltip>
        </div>
        <div className=" flex items-center justify-between  mb-6">
            <span className={leftClassName}>{t('flow.timeOfPledge')}</span>
            <PresentData className={rightClassName} value={dayjs((Number(formatUnits(data.startTime, 0)) * 1000)).format('YYYY.MM.DD HH:mm')
            } loading={demandsLod} />
        </div>
        {data.isWithdrawn ?
            <ButtonDefault
                className="!rounded-md" block text={t('flow.redeemed')} />
            :
            <div className=" flex items-center justify-between gap-3">
                <ButtonDefault disabled={demandsLod} text={t('flow.redemption')}
                    className=" !rounded-md flex-1" loading={flowWithdrawLod} onClick={getFlowWithdrawFun} />

                <ButtonPrimary text={t('flow.extractingEarnings')} disabled={demandsLod} className=" !rounded-md flex-1" loading={flowClaimLod} onClick={getFlowClaimFun} />
            </div>
        }
    </div >
}
export default History